import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import Man2OutlinedIcon from '@mui/icons-material/Man2Outlined'
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined'
import CarRentalOutlinedIcon from '@mui/icons-material/CarRentalOutlined'
import BikeScooterOutlinedIcon from '@mui/icons-material/BikeScooterOutlined'
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined'
import TwoWheelerOutlinedIcon from '@mui/icons-material/TwoWheelerOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'

import LayoutMenuItemUI from './LayoutMenuItemUI'

const layoutMenu = (t: any) => {
  return {
    home: {
      menu: {
        id: 'home',
        text: t('menu.home'),
        icon: <HomeOutlinedIcon />,
        url: '/',
      } as LayoutMenuItemUI,
      submenu: [],
    },
    users: {
      menu: {
        id: 'users',
        text: t('menu.users'),
        icon: <PersonOutlinedIcon />,
      } as LayoutMenuItemUI,
      submenu: [
        {
          id: 'administrators',
          text: t('menu.administrators'),
          icon: <ManageAccountsOutlinedIcon />,
          url: '/administrators',
        } as LayoutMenuItemUI,
        {
          id: 'teachers',
          text: t('menu.teachers'),
          icon: <Man2OutlinedIcon />,
          url: '/teachers',
        } as LayoutMenuItemUI,
        {
          id: 'students',
          text: t('menu.students'),
          icon: <ChildCareOutlinedIcon />,
          url: '/students',
        } as LayoutMenuItemUI,
      ],
    },
    lessons: {
      menu: {
        id: 'lessons',
        text: t('menu.lessons'),
        icon: <SchoolOutlinedIcon />,
      } as LayoutMenuItemUI,
      submenu: [
        {
          id: 'theory',
          text: t('menu.theory'),
          icon: <LocalLibraryOutlinedIcon />,
          url: '/theory-lessons',
        } as LayoutMenuItemUI,
        {
          id: 'driving',
          text: t('menu.driving'),
          icon: <CarRentalOutlinedIcon />,
          url: '/driving-lessons',
        } as LayoutMenuItemUI,
      ],
    },
    vehicles: {
      menu: {
        id: 'vehicles',
        text: t('menu.vehicles'),
        icon: <BikeScooterOutlinedIcon />,
      } as LayoutMenuItemUI,
      submenu: [
        {
          id: 'cars',
          text: t('menu.cars'),
          icon: <DirectionsCarFilledOutlinedIcon />,
          url: '/school-cars',
        } as LayoutMenuItemUI,
        {
          id: 'motorcycles',
          text: t('menu.motorcycles'),
          icon: <TwoWheelerOutlinedIcon />,
          url: '/school-motorcycles',
        } as LayoutMenuItemUI,
        {
          id: 'trucks',
          text: t('menu.trucks'),
          icon: <LocalShippingOutlinedIcon />,
          url: '/school-trucks',
        } as LayoutMenuItemUI,
      ],
    },
    calendar: {
      menu: {
        id: 'calendar',
        text: t('menu.calendar'),
        icon: <CalendarMonthOutlinedIcon />,
        url: '/calendar',
      } as LayoutMenuItemUI,
      submenu: [],
    },
    settings: {
      menu: {
        id: 'settings',
        text: t('menu.settings'),
        icon: <SettingsOutlinedIcon />,
        url: '/settings',
      } as LayoutMenuItemUI,
      submenu: [],
    },
  }
}

export default layoutMenu
